import { useEffect, useState } from 'react';
import {
  Job,
  JobApplication,
  JobApplicationStatus,
} from '@core/generated/gql-types';
import { useJobApplicationStore } from '@core/jobApplication/useJobApplicationStore';
import SelectWorkerHeader from './SelectWorkerHeader';
import SelectWorkerOptions from './SelectWorkerOptions';

interface SelectWorkerProps {
  job: Job;
  showAllApplicants?: boolean;
  showWorkerPayRate?: boolean;
}

const SelectWorker = ({
  job,
  showAllApplicants = true,
  showWorkerPayRate = true,
}: SelectWorkerProps) => {
  const [jobApplications, setJobApplications] = useState<JobApplication[]>([]);

  const [loading, setLoading] = useState(false);

  const [openWorkerSearchModal, setOpenWorkerSearchModal] = useState(false);

  const { jobApplications: jobApplicationsCache } = useJobApplicationStore();

  // Fetch the job applications for the job.
  useEffect(() => {
    setLoading(true);
    const applications = jobApplicationsCache.filter(
      (application) => application.jobId === job.id,
    );

    // Filter out the applications that are not in pending status.
    const validApplications = applications.filter(
      (application) => application.itemStatus == JobApplicationStatus.Pending,
    );

    setJobApplications(validApplications);

    setLoading(false);
  }, [job.id, jobApplicationsCache]);

  return (
    <div>
      <SelectWorkerHeader
        job={job}
        jobApplications={jobApplications}
        setOpenWorkerSearchModal={setOpenWorkerSearchModal}
        openWorkerSearchModal={openWorkerSearchModal}
        allowWorkerSearch={showAllApplicants}
      />

      <SelectWorkerOptions
        job={job}
        jobApplications={jobApplications}
        loading={loading}
        setLoading={setLoading}
        openWorkerSearchModal={openWorkerSearchModal}
        setOpenWorkerSearchModal={setOpenWorkerSearchModal}
        showAllApplicants={showAllApplicants}
        showWorkerPayRate={showWorkerPayRate}
      />
    </div>
  );
};

export default SelectWorker;
